module.exports = __webpack_public_path__ + "img/scouttools_logo.85e5ca26.svg";